import {
  primaryColors,
  transparentColors,
  whiteShades,
} from "../../assets/styles/helpers/colors.styles";

/**
 * One colour for every part of an errored field: the outline, the label in the
 * notch and the message underneath. The theme's primary at 60%, the same as
 * the placeholder.
 *
 * Forced, because the focused-state rules carry !important of their own and
 * these fields are rendered focused, so without it the outline would keep the
 * focused colour while the label and the message changed.
 */
const errorColor = transparentColors.whiteShade6;

export const inputStyles = {
  width: "100%",

  ".Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${primaryColors.white} !important`,
  },

  ".Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: `${errorColor} !important`,
  },

  ".Mui-error.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: `${errorColor} !important`,
  },

  // Beats the forced-focus outline, which is itself !important.
  ".Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${errorColor} !important`,
  },

  ".MuiInputBase-root input": {
    textTransform: "none",
  },

  ".MuiInputBase-root:has(textarea)": {
    padding: "0.5rem",
  },

  ".MuiFormLabel-root": {
    color: whiteShades.shade1,
    fontFamily: "Helvetica Neue, sans-serif",
    fontWeight: 900,
    fontStretch: "condensed",
    fontSize: "0.875rem",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    transform: "translate(14px, 7px) scale(1)",
    zIndex: 0,

    '&[data-shrink="true"]': {
      transform: "translate(14px, -10px) scale(0.75)",
      color: primaryColors.white,
    },
  },

  ".MuiOutlinedInput-notchedOutline": {
    border: `2px solid ${primaryColors.white}`,
    "&:hover": {
      borderColor: `${primaryColors.white}`,
    },
    "legend span": {
      fontFamily: "Helvetica Neue, sans-serif",
      fontWeight: 900,
      fontStretch: "condensed",
      textTransform: "uppercase",
      fontSize: "0.65rem",
      "&:not(:empty)": {
        paddingLeft: "0.25rem",
        paddingRight: "0.25rem",
      },
    },
  },

  ".Mui-disabled": {
    ".MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${whiteShades.shade1}`,
    },
    "&.MuiFormLabel-root": {
      color: whiteShades.shade1,
      textTransform: "uppercase",
    },
  },

  ".Mui-error": {
    ".MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${errorColor} !important`,
    },
    "&.MuiFormLabel-root": {
      color: `${errorColor} !important`,
      textTransform: "uppercase",
    },
  },

  ".MuiAutocomplete-root.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline":
    {
      borderColor: errorColor,
    },

  ".MuiInputBase-root .Mui-error:hover .MuiOutlinedInput-notchedOutline": {
    border: `2px solid ${errorColor} !important`,
  },

  ".MuiFormHelperText-root": {
    fontFamily: "Helvetica Neue, sans-serif",
    fontWeight: 900,
    fontStretch: "condensed",
    textTransform: "uppercase",
    fontSize: "0.65rem",
    margin: 0,

    "&.Mui-error": {
      color: `${errorColor} !important`,
    },
  },

  ".MuiInputBase-root .Mui-disabled": {
    color: whiteShades.shade1,
    "-webkit-text-fill-color": whiteShades.shade1,
    textTransform: "none",
  },

  ".MuiOutlinedInput-root": {
    color: primaryColors.white,
  },

  ".MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: `${primaryColors.white}`,
  },

  "&.MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderColor: `${primaryColors.white}`,
    },

  ".MuiInputBase-input": {
    fontSize: "0.875rem",
    fontFamily: "Helvetica Neue, sans-serif",
    fontWeight: 900,
    fontStretch: "condensed",

    padding: "0.5rem 0.75rem",
    "&::-webkit-scrollbar": {
      width: "0.5rem",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: transparentColors.orangeShade4,
      borderRadius: "0.5rem",
      cursor: "pointer",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: transparentColors.transparent,
      borderRadius: "0.5rem",
    },
    "&::placeholder": {
      color: transparentColors.whiteShade6,
      opacity: 1,
      fontFamily: "Helvetica Neue, sans-serif",
      fontWeight: 900,
      fontStretch: "condensed",
    },
  },

  ".MuiInputBase-input.MuiInputBase-inputMultiline": {
    padding: "0 0.25rem",
  },

  ".MuiOutlinedInput-input": {
    height: "1.125rem",
  },
};

export const inputAdornmentStyles = {};
